import styled from 'styled-components';

export const FooterContainer = styled.div`
background: #F0FFE6;
width: 100%;
background-repeat: no-repeat;
background-size: cover;
background-position: center;
`;

export const FooterWrapper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
max-width: 1400px;
margin-left: auto;
margin-right: auto;
padding: 25px 25px;
`;

export const FooterLogo = styled.img`
width: 100%;
max-width: 250px;
height: auto;
margin-left: auto;
margin-right: auto;

@media screen and (max-width: 768px){
    max-width: 250px;
}

@media screen and (max-width: 480px){
    max-width: 200px;
}

&:hover {
    cursor: pointer;
    transition: 0.2s all ease-in-out;
    transform: scale(1.02);
}
`;

export const IconsWrapper = styled.div`
display: flex;
flex-direction: row;
justify-content: center;
gap: 25px;
margin-top: 50px;
`;

export const FooterIcon = styled.a`
color: #33682c;
font-size: 24px;

&:hover {
    transition: 0.2s all ease-in-out;
    transform: scale(1.05);
}
`;

export const FooterCopyright = styled.p`
color: #101110;
font-size: 18px;
text-align: center;
margin-top: 25px;

@media screen and (max-width: 768px){
    font-size: 14px;
}

@media screen and (max-width: 480px){
    font-size: 12px;
}
`;

export const FooterTextWrapper = styled.div`
display: flex;
flex-direction: row;
justify-content: center;
gap: 25px;
margin-top: 50px;
`;

export const FooterText = styled.a`
color: #101110;
font-size: 18px;
text-decoration: none;
text-align: center;

&:hover {
    transition: 0.2s all ease-in-out;
    transform: scale(1.05);
    cursor: pointer;
}

@media screen and (max-width: 768px){
    font-size: 14px;
}

@media screen and (max-width: 480px){
    font-size: 12px;
}
`;
